import MobileDetect from 'mobile-detect';
import './modernizr';

export default function initializeModernizr() {
  window.Modernizr.addTest('shouldHover', () => {
    const md = new MobileDetect(window.navigator.userAgent);

    if (!(window.Modernizr.touchevents || md.mobile())) {
      return true;
    } else {
      return false;
    }
  });
}
